import React, { Component } from "react";
import ButtonAlt from "../../../ButtonAlt/ButtonAlt";
import ExistingCustomers from "./ExistingCustomers/ExistingCustomers";
import PotentialCustomers from "./PotentialCustomers/PotentialCustomers";
import "./CustomersOptions.css";

class CustomersOptions extends Component {
	render() {
		return (
		
				<div className="left-customers-options">

					<ExistingCustomers
						query={this.props.query}
						buildSearchQuery={this.props.buildSearchQuery}
					/>
					<ButtonAlt
						label={
							this.props.moreFilters === true ? "Hide Filters" : "More Filters"
						}
						onClick={() => this.props.toggleMoreFilters()}
					/>
					{this.props.moreFilters === true && (
						<div>
							<PotentialCustomers
								query={this.props.query}
								buildSearchQuery={this.props.buildSearchQuery}
							/>
						</div>
					)}
				</div>
		);
	}
}

export default CustomersOptions;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/CustomersOptions/CustomersOptions.js